import React, { Fragment } from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import OSSTableRow from "./OSSTableRow";

const styles = theme => ({
  noResultsTableCell: {
    padding: theme.spacing(1)
  }
});

const OSSTableBody = ({
  classes,
  config = {},
  data = {},
  NoTableDataMessage
}) => {
  const { columns, additionalRowComponent } = config;
  const { results, isLoading } = data;
  const noResults = !results || !results.length;

  if (noResults && !isLoading) {
    return (
      <TableBody>
        <TableRow>
          <TableCell
            colSpan={columns.length}
            className={classes.noResultsTableCell}
          >
            <NoTableDataMessage />
          </TableCell>
        </TableRow>
      </TableBody>
    );
  }

  return (
    <TableBody>
      {results.map((row, index) => (
        <Fragment key={index}>
          <OSSTableRow config={config} row={row} />
          {additionalRowComponent && (
            <TableRow>
              <TableCell padding="none" colSpan="100">
                {OSSTableBody.AdditionalRowComponent(
                  row,
                  additionalRowComponent
                )}
              </TableCell>
            </TableRow>
          )}
        </Fragment>
      ))}
    </TableBody>
  );
};

OSSTableBody.AdditionalRowComponent = (row, additionalRowComponent) => {
  const validComponent = React.isValidElement(additionalRowComponent)
    ? additionalRowComponent
    : null;

  return React.cloneElement(validComponent, { row });
};

OSSTableBody.propTypes = {
  classes: PropTypes.object.isRequired,
  config: PropTypes.shape({
    columns: PropTypes.arrayOf(PropTypes.object).isRequired
  }).isRequired,
  data: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.object).isRequired
  }).isRequired
};

export default withStyles(styles)(OSSTableBody);
